
<div *ngIf="show" class="wizard-container">
  <div class="row float-right"><button class="nrk-button mr-3" (click)="close()">close</button></div>

  <ngx-erp-base-product #baseProductRef
    *ngIf="showPage === eShowPage.baseProduct" 
    [fromWizard]="this" 
    [baseProduct]="baseProduct"
    (wizardAction)="wizardAction($event)">
  </ngx-erp-base-product>

  <ngx-erp-finished-product #finishedProductRef
    *ngIf="showPage === eShowPage.finishedProduct"
    [fromWizard]="this"
    [baseProduct]="baseProduct"
    [finishedProduct]="finishedProduct"
    [compilation]="compilation"
    (wizardAction)="wizardAction($event)">
  </ngx-erp-finished-product>

  <ngx-erp-price-matrix
    *ngIf="showPage === eShowPage.priceMatrix"
    [fromWizard]="this"
    [finishedProduct]="finishedProduct"
    [issuer]="compilation.issuer"
    (wizardAction)="wizardAction($event)">
  </ngx-erp-price-matrix>

  <ngx-base-product-matrix
    *ngIf="showPage === eShowPage.baseProductMatrix"
    [fromWizard]="this"
    [baseProduct]="baseProduct"
    [finishedProducts]="finishedProducts"
    [issuer]="compilation.issuer"
    [fromOfferTemplate]="offerWizard"
    [newBaseProduct]="newBaseProduct"
    [compilation]="compilation"
    (wizardAction)="wizardAction($event)">
  </ngx-base-product-matrix>

</div>
